(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kw-card-color-indicators"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-card-colors')) {
    customElements.define('kw-card-colors', class extends HTMLElement {
      constructor() {
        super();
        this.requestId = 0;
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.card = this.closest('.card-wrapper');
        this.image = this.card?.querySelector('.card__media .media > img');
        if (!this.image) return;
        this.querySelectorAll('.kw-card-color[data-image-src]').forEach((swatch) => {
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('aria-pressed', swatch.dataset.selected);
        });
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
      }

      disconnectedCallback() {
        this.requestId++;
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
      }

      handleKeydown(event) {
        const swatch = event.target.closest('.kw-card-color[role="button"]');
        if (event.key !== ' ' || !swatch) return;
        event.preventDefault();
        swatch.click();
      }

      async handleClick(event) {
        const swatch = event.target.closest('.kw-card-color[data-image-src]');
        if (!swatch || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const requestId = ++this.requestId;
        const preview = new Image();
        preview.sizes = this.image.sizes;
        preview.srcset = swatch.dataset.imageSrcset;
        preview.src = swatch.dataset.imageSrc;
        this.setAttribute('aria-busy', 'true');
        try {
          await preview.decode();
        } catch {
          if (this.isConnected && requestId === this.requestId) {
            this.removeAttribute('aria-busy');
            window.location.assign(swatch.href);
          }
          return;
        }
        if (!this.isConnected || requestId !== this.requestId) return;
        this.image.srcset = swatch.dataset.imageSrcset;
        this.image.src = swatch.dataset.imageSrc;
        this.image.alt = swatch.dataset.imageAlt;
        this.image.width = Number(swatch.dataset.imageWidth);
        this.image.height = Number(swatch.dataset.imageHeight);
        this.image.parentElement.classList.remove('media--hover-effect');
        this.card.classList.add('kw-color-preview-selected');
        this.querySelectorAll('.kw-card-color[role="button"]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === swatch));
        });
        this.card.querySelectorAll('.card__heading a').forEach((link) => {
          link.href = swatch.href;
        });
        this.card.querySelectorAll('[data-product-url]').forEach((button) => {
          button.dataset.productUrl = swatch.href;
        });
        this.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kw-dismiss-search]');
    if (!button) return;
    const search = button.closest('predictive-search');
    if (!search) return;
    search.input.focus({ preventScroll: true });
    search.close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const search = event.target.closest('predictive-search.kw-header-search[open]');
    if (!search) return;
    search.close();
    event.preventDefault();
    event.stopPropagation();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-mobile-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-mobile-navigation')) {
    customElements.define('kw-mobile-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.kw-mobile-navigation__trigger');
        this.trigger.addEventListener('click', () => {
          this.scrollPosition = window.scrollY;
          this.previousTop = document.body.style.top;
          this.dialog.showModal();
          this.dialog.scrollTop = 0;
          document.body.style.top = `-${this.scrollPosition}px`;
          document.body.classList.add('kw-mobile-navigation-open');
          this.trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.dialog.addEventListener('close', () => this.restorePage(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('a[href]')) this.dialog.close();
        }, options);
        this.media = window.matchMedia('(min-width: 990px)');
        this.media.addEventListener('change', () => {
          if (this.media.matches && this.dialog.open) this.dialog.close();
        }, options);
      }
      restorePage() {
        if (this.scrollPosition === undefined) return;
        document.body.classList.remove('kw-mobile-navigation-open');
        document.body.style.top = this.previousTop;
        window.scrollTo({ top: this.scrollPosition, behavior: 'instant' });
        this.scrollPosition = undefined;
        this.trigger.setAttribute('aria-expanded', 'false');
      }
      disconnectedCallback() {
        this.restorePage();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-phone-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
  function phoneCheckoutLink(cart, shopUrl, cartPath) {
    if (!cart.items?.length) throw new Error('empty');
    if (cart.items.some(item => item.selling_plan_allocation || item.parent_relationship || item.item_components?.length || Object.keys(item.properties || {}).length)) throw new Error('unsupported');
    const quantities = new Map();
    for (const item of cart.items) {
      const id = String(item.variant_id);
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('unavailable');
      quantities.set(id, (quantities.get(id) || 0) + item.quantity);
    }
    const url = new URL(`${cartPath.replace(/\/$/, '')}/${Array.from(quantities, ([id, quantity]) => `${id}:${quantity}`).join(',')}`, shopUrl);
    if (url.protocol !== 'https:') throw new Error('unavailable');
    const discounts = new Set();
    for (const discount of cart.discount_codes || []) {
      if (discount.applicable !== false && discount.code) discounts.add(discount.code);
    }
    const applications = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    for (const discount of applications) {
      if (discount?.type === 'discount_code' && discount.title) discounts.add(discount.title);
    }
    if ([...discounts].some(code => code.includes(','))) throw new Error('unsupported');
    if (discounts.size) url.searchParams.set('discount', [...discounts].join(','));
    if (cart.note) url.searchParams.set('note', cart.note);
    for (const [key, value] of Object.entries(cart.attributes || {})) {
      if (value !== null && value !== '') url.searchParams.set(`attributes[${key}]`, String(value));
    }
    return url.href;
  }

  function phoneQrMatrix(text) {
    const variants = [
      [4, 20, [80], [6, 26]],
      [6, 18, [68, 68], [6, 34]],
      [8, 24, [97, 97], [6, 24, 42]],
      [10, 18, [68, 68, 69, 69], [6, 28, 50]],
      [12, 24, [92, 92, 93, 93], [6, 32, 58]],
      [15, 22, [87, 87, 87, 87, 87, 88], [6, 26, 48, 70]],
      [20, 28, [107, 107, 107, 108, 108, 108, 108, 108], [6, 34, 62, 90]]
    ];
    const bytes = new TextEncoder().encode(text);
    const variant = variants.find(([version, , lengths]) => bytes.length * 8 + 4 + (version < 10 ? 8 : 16) <= lengths.reduce((sum, length) => sum + length, 0) * 8);
    if (!variant) throw new Error('too_large');
    const [version, ecLength, lengths, alignment] = variant;
    const capacity = lengths.reduce((sum, length) => sum + length, 0);
    const bits = [];
    const append = (value, length) => { for (let i = length - 1; i >= 0; i--) bits.push((value >>> i) & 1); };
    append(4, 4);
    append(bytes.length, version < 10 ? 8 : 16);
    bytes.forEach(value => append(value, 8));
    append(0, Math.min(4, capacity * 8 - bits.length));
    while (bits.length % 8) bits.push(0);
    const data = [];
    for (let i = 0; i < bits.length; i += 8) data.push(bits.slice(i, i + 8).reduce((value, bit) => (value << 1) | bit, 0));
    for (let pad = 0; data.length < capacity; pad++) data.push(pad % 2 ? 0x11 : 0xec);
    const multiply = (a, b) => {
      let result = 0;
      for (let i = 7; i >= 0; i--) {
        result = (result << 1) ^ ((result >>> 7) * 0x11d);
        result ^= ((b >>> i) & 1) * a;
      }
      return result;
    };
    const divisor = Array(ecLength).fill(0);
    divisor[ecLength - 1] = 1;
    let root = 1;
    for (let i = 0; i < ecLength; i++) {
      for (let j = 0; j < ecLength; j++) divisor[j] = multiply(divisor[j], root) ^ (divisor[j + 1] || 0);
      root = multiply(root, 2);
    }
    let offset = 0;
    const blocks = lengths.map(length => {
      const chunk = data.slice(offset, offset += length);
      const correction = Array(ecLength).fill(0);
      for (const value of chunk) {
        const factor = value ^ correction.shift();
        correction.push(0);
        divisor.forEach((coefficient, i) => { correction[i] ^= multiply(coefficient, factor); });
      }
      return { chunk, correction };
    });
    const words = [];
    for (let i = 0; i < Math.max(...lengths); i++) blocks.forEach(block => { if (i < block.chunk.length) words.push(block.chunk[i]); });
    for (let i = 0; i < ecLength; i++) blocks.forEach(block => words.push(block.correction[i]));
    const size = 17 + 4 * version;
    const matrix = Array.from({ length: size }, () => Array(size).fill(false));
    const fixed = Array.from({ length: size }, () => Array(size).fill(false));
    const set = (x, y, value) => {
      if (x >= 0 && x < size && y >= 0 && y < size) { matrix[y][x] = !!value; fixed[y][x] = true; }
    };
    for (let i = 0; i < size; i++) { set(6, i, i % 2 === 0); set(i, 6, i % 2 === 0); }
    for (const [x, y] of [[3, 3], [size - 4, 3], [3, size - 4]]) {
      for (let dy = -4; dy <= 4; dy++) for (let dx = -4; dx <= 4; dx++) {
        const distance = Math.max(Math.abs(dx), Math.abs(dy));
        set(x + dx, y + dy, distance !== 2 && distance !== 4);
      }
    }
    alignment.forEach((x, i) => alignment.forEach((y, j) => {
      if ((i === 0 && (j === 0 || j === alignment.length - 1)) || (i === alignment.length - 1 && j === 0)) return;
      for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) set(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
    }));
    const format = mask => {
      const value = (1 << 3) | mask;
      let remainder = value;
      for (let i = 0; i < 10; i++) remainder = (remainder << 1) ^ ((remainder >>> 9) * 0x537);
      const code = ((value << 10) | remainder) ^ 0x5412;
      const bit = i => (code >>> i) & 1;
      for (let i = 0; i <= 5; i++) set(8, i, bit(i));
      set(8, 7, bit(6)); set(8, 8, bit(7)); set(7, 8, bit(8));
      for (let i = 9; i < 15; i++) set(14 - i, 8, bit(i));
      for (let i = 0; i < 8; i++) set(size - 1 - i, 8, bit(i));
      for (let i = 8; i < 15; i++) set(8, size - 15 + i, bit(i));
      set(8, size - 8, true);
    };
    format(0);
    if (version >= 7) {
      let remainder = version;
      for (let i = 0; i < 12; i++) remainder = (remainder << 1) ^ ((remainder >>> 11) * 0x1f25);
      const code = (version << 12) | remainder;
      for (let i = 0; i < 18; i++) {
        const a = size - 11 + i % 3;
        const b = Math.floor(i / 3);
        set(a, b, (code >>> i) & 1); set(b, a, (code >>> i) & 1);
      }
    }
    let bitIndex = 0;
    for (let right = size - 1; right >= 1; right -= 2) {
      if (right === 6) right--;
      for (let vertical = 0; vertical < size; vertical++) {
        const y = ((right + 1) & 2) === 0 ? size - 1 - vertical : vertical;
        for (let column = 0; column < 2; column++) {
          const x = right - column;
          if (!fixed[y][x]) {
            matrix[y][x] = bitIndex < words.length * 8 && !!((words[bitIndex >>> 3] >>> (7 - bitIndex % 8)) & 1);
            bitIndex++;
          }
        }
      }
    }
    const masks = [
      (x, y) => (x + y) % 2 === 0, (x, y) => y % 2 === 0, x => x % 3 === 0,
      (x, y) => (x + y) % 3 === 0, (x, y) => (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0,
      (x, y) => x * y % 2 + x * y % 3 === 0, (x, y) => (x * y % 2 + x * y % 3) % 2 === 0,
      (x, y) => ((x + y) % 2 + x * y % 3) % 2 === 0
    ];
    const maskData = mask => {
      for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) if (!fixed[y][x] && masks[mask](x, y)) matrix[y][x] = !matrix[y][x];
    };
    const penalty = () => {
      let score = 0;
      let dark = 0;
      const lineScore = line => {
        let result = 0;
        let run = 1;
        for (let i = 1; i < size; i++) {
          if (line[i] === line[i - 1]) { run++; if (run === 5) result += 3; else if (run > 5) result++; } else run = 1;
        }
        const textLine = line.map(value => value ? '1' : '0').join('');
        for (let i = 0; i <= size - 11; i++) if (['00001011101', '10111010000'].includes(textLine.slice(i, i + 11))) result += 40;
        return result;
      };
      for (let y = 0; y < size; y++) {
        score += lineScore(matrix[y]) + lineScore(matrix.map(row => row[y]));
        for (let x = 0; x < size; x++) {
          if (matrix[y][x]) dark++;
          if (x && y && matrix[y][x] === matrix[y - 1][x] && matrix[y][x] === matrix[y][x - 1] && matrix[y][x] === matrix[y - 1][x - 1]) score += 3;
        }
      }
      return score + Math.floor(Math.abs(dark * 20 - size * size * 10) / (size * size)) * 10;
    };
    let best = 0;
    let bestScore = Infinity;
    for (let mask = 0; mask < 8; mask++) {
      maskData(mask); format(mask);
      const score = penalty();
      if (score < bestScore) { best = mask; bestScore = score; }
      maskData(mask);
    }
    maskData(best); format(best);
    return matrix;
  }

  class PhoneCheckout extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog.showModal) return;
      this.strings = JSON.parse(this.querySelector('[data-phone-strings]').textContent);
      this.status = this.querySelector('[data-phone-status]');
      this.ready = this.querySelector('[data-phone-ready]');
      this.retry = this.querySelector('[data-phone-retry]');
      this.link = this.querySelector('[data-phone-link]');
      this.copyButton = this.querySelector('[data-phone-copy]');
      this.linkWrap = this.querySelector('[data-phone-link-wrap]');
      this.sequence = 0;
      this.openHandler = event => {
        const trigger = event.target.closest('[data-kw-phone-checkout]');
        if (!trigger || this.dialog.open) return;
        event.preventDefault();
        this.trigger = trigger;
        this.drawer = trigger.closest('cart-drawer');
        if (this.drawer && typeof removeTrapFocus === 'function') removeTrapFocus();
        this.dialog.showModal();
        document.body.classList.add('kw-phone-checkout-open');
        this.refresh();
      };
      document.addEventListener('click', this.openHandler);
      this.querySelectorAll('[data-phone-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.escapeReleaseHandler = event => {
        if (event.key === 'Escape') event.stopPropagation();
        document.removeEventListener('keyup', this.escapeReleaseHandler, true);
      };
      this.dialog.addEventListener('cancel', () => document.addEventListener('keyup', this.escapeReleaseHandler, true));
      this.dialog.addEventListener('close', () => {
        this.sequence++;
        this.controller?.abort();
        document.body.classList.remove('kw-phone-checkout-open');
        const trigger = this.trigger?.isConnected ? this.trigger : document.querySelector('[data-kw-phone-checkout]:not([hidden])');
        if (this.drawer?.classList.contains('active') && typeof trapFocus === 'function') trapFocus(this.drawer.querySelector('.drawer__inner'), trigger);
        else trigger?.focus();
      });
      this.querySelector('[data-phone-refresh]').addEventListener('click', () => this.refresh());
      this.retry.addEventListener('click', () => this.refresh());
      this.copyButton.addEventListener('click', () => this.copy());
      this.focusHandler = () => { if (this.dialog.open && !document.hidden) this.refresh(); };
      window.addEventListener('focus', this.focusHandler);
      this.cartChangeHandler = event => {
        if (event.target.matches('[name="updates[]"], cart-note textarea')) this.lastCartChange = Date.now();
      };
      document.addEventListener('change', this.cartChangeHandler, true);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { this.updateButtons(); if (this.dialog.open) this.refresh(); });
      }
      this.observer = new MutationObserver(() => this.updateButtons());
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      document.documentElement.classList.add('kw-phone-checkout-available');
      this.updateButtons();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.openHandler);
      document.removeEventListener('change', this.cartChangeHandler, true);
      document.removeEventListener('keyup', this.escapeReleaseHandler, true);
      window.removeEventListener('focus', this.focusHandler);
      this.observer?.disconnect();
      this.unsubscribe?.();
      this.controller?.abort();
      document.body.classList.remove('kw-phone-checkout-open');
      document.documentElement.classList.remove('kw-phone-checkout-available');
    }

    updateButtons() {
      document.querySelectorAll('[data-kw-phone-checkout]').forEach(button => {
        const empty = !!button.closest('.is-empty');
        if (button.hidden !== empty) button.hidden = empty;
      });
    }

    async refresh() {
      const sequence = ++this.sequence;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const signal = controller.signal;
      this.ready.hidden = true;
      this.retry.hidden = true;
      this.linkWrap.hidden = true;
      if (this.dialog.open) {
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        if (!this.dialog.contains(document.activeElement)) this.querySelector('[data-phone-close]').focus();
      }
      this.link.value = '';
      this.copyButton.textContent = this.strings.copy;
      this.status.textContent = this.strings.loading;
      this.dialog.setAttribute('aria-busy', 'true');
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        while (document.querySelector('.cart__items--disabled') || Date.now() - (this.lastCartChange || 0) < 600) {
          if (signal.aborted || sequence !== this.sequence) throw new Error('unavailable');
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        const response = await fetch(`${this.dataset.cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('unavailable');
        const cart = await response.json();
        const link = phoneCheckoutLink(cart, this.dataset.shopUrl, this.dataset.cartUrl);
        const matrix = phoneQrMatrix(link);
        if (sequence !== this.sequence || !this.dialog.open) return;
        const namespace = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(namespace, 'svg');
        svg.setAttribute('viewBox', `0 0 ${matrix.length + 8} ${matrix.length + 8}`);
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('shape-rendering', 'crispEdges');
        const background = document.createElementNS(namespace, 'rect');
        background.setAttribute('width', '100%'); background.setAttribute('height', '100%'); background.setAttribute('fill', '#fff');
        const path = document.createElementNS(namespace, 'path');
        path.setAttribute('fill', '#000');
        path.setAttribute('d', matrix.flatMap((row, y) => row.flatMap((dark, x) => dark ? [`M${x + 4},${y + 4}h1v1h-1z`] : [])).join(''));
        svg.append(background, path);
        this.querySelector('[data-phone-qr]').replaceChildren(svg);
        this.link.value = link;
        this.querySelector('[data-phone-count]').textContent = (cart.item_count === 1 ? this.strings.one_item : this.strings.items).replace('[count]', cart.item_count);
        this.status.textContent = '';
        this.ready.hidden = false;
      } catch (error) {
        if (sequence !== this.sequence || !this.dialog.open) return;
        this.status.textContent = this.strings[error.message] || this.strings.unavailable;
        this.retry.hidden = ['empty', 'unsupported', 'too_large'].includes(error.message);
      } finally {
        clearTimeout(timeout);
        if (sequence === this.sequence) this.dialog.removeAttribute('aria-busy');
      }
    }

    async copy() {
      if (!this.link.value) return;
      try {
        await navigator.clipboard.writeText(this.link.value);
        this.status.textContent = this.strings.copied;
        this.copyButton.textContent = this.strings.copied;
      } catch {
        this.linkWrap.hidden = false;
        this.link.focus();
        this.link.select();
        this.status.textContent = this.strings.copy_fallback;
      }
    }
  }
  if (!customElements.get('kw-phone-checkout')) customElements.define('kw-phone-checkout', PhoneCheckout);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-product-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-product-colors')) {
    customElements.define('kw-product-colors', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.picker = this.closest('variant-selects');
        this.picker?.addEventListener('change', () => this.queueSync(), options);
        this.addEventListener('pointerover', (event) => {
          if (event.pointerType === 'touch') return;
          const label = event.target.closest('.kw-product-colors__label');
          if (label?.control) this.showName(label.control.value);
        }, options);
        this.addEventListener('pointerleave', () => this.showSelectedName(), options);
        this.addEventListener('focusin', (event) => {
          if (event.target.matches('[data-kw-color]')) this.showName(event.target.value);
        }, options);
        this.addEventListener('focusout', () => this.showSelectedName(), options);
        this.queueSync();
      }

      disconnectedCallback() {
        this.events.abort();
        cancelAnimationFrame(this.frame);
        this.buttonObserver?.disconnect();
      }

      queueSync() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncSelection());
      }

      get selectedInput() { return this.querySelector('[data-kw-color]:checked'); }

      showName(value) {
        const name = this.querySelector('[data-selected-value]');
        if (name) name.textContent = value || '';
      }

      showSelectedName() { this.showName(this.selectedInput?.value); }

      syncSelection() {
        this.showSelectedName();
        if (!this.picker) return;
        const input = this.selectedInput;
        const button = this.querySelector('[data-kw-color]')?.form?.querySelector('button[name="add"]');
        if (!button) return;
        if (button !== this.button) {
          this.buttonObserver?.disconnect();
          this.button = button;
          this.buttonObserver = new MutationObserver(() => this.queueSync());
          this.buttonObserver.observe(button, { attributes: true, attributeFilter: ['disabled'] });
        }
        let variant;
        try {
          variant = JSON.parse(this.picker.querySelector('[data-selected-variant]').textContent);
        } catch {
          variant = null;
        }
        const selectedValues = Array.from(this.picker.querySelectorAll('fieldset, .product-form__input--dropdown')).map((group) =>
          group.querySelector('input:checked')?.value ?? group.querySelector('select')?.value
        );
        const selectionReady = input && variant?.available && !button.disabled &&
          input.form?.querySelector('[name="id"]')?.value === String(variant.id) &&
          selectedValues.length === variant.options.length &&
          selectedValues.every((value, index) => value === variant.options[index]);
        const channels = input?.dataset.buttonColor?.match(/[\d.]+/g)?.slice(0, 3).map(Number);
        if (!selectionReady || !channels || channels.length !== 3 || channels.some((channel) => !Number.isFinite(channel) || channel < 0 || channel > 255)) {
          button.classList.remove('kw-color-submit');
          button.style.removeProperty('--kw-button-color');
          button.style.removeProperty('--kw-button-ink');
          return;
        }
        const linear = channels.map((channel) => {
          const value = channel / 255;
          return value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4;
        });
        const luminance = linear[0] * .2126 + linear[1] * .7152 + linear[2] * .0722;
        const whiteContrast = 1.05 / (luminance + .05);
        const blackContrast = (luminance + .05) / .05;
        button.style.setProperty('--kw-button-color', channels.join(', '));
        button.style.setProperty('--kw-button-ink', whiteContrast > blackContrast ? '255, 255, 255' : '0, 0, 0');
        button.classList.add('kw-color-submit');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kw-size-chart')) {
    customElements.define('kw-size-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-chart-open]');
        const content = this.querySelector('[data-chart-content]');
        const source = this.querySelector('template').content;
        const chart = this.descriptionChart(source);
        if (chart) content.replaceChildren(chart);
        if (!content.textContent.trim() && !content.querySelector('img')) return;
        content.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        content.querySelectorAll('table').forEach((table, index) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'kw-size-chart__table';
          wrapper.setAttribute('role', 'region');
          const heading = table.previousElementSibling;
          wrapper.setAttribute('aria-label', `${opener.textContent.trim()} — ${heading?.textContent.trim() || index + 1}`);
          table.before(wrapper);
          wrapper.append(table);
          const mobileTable = this.mobileTable(table);
          if (mobileTable) {
            wrapper.classList.add('kw-size-chart__table--desktop');
            const mobileWrapper = wrapper.cloneNode(false);
            mobileWrapper.className = 'kw-size-chart__table kw-size-chart__table--mobile';
            mobileWrapper.append(mobileTable);
            wrapper.after(mobileWrapper);
          }
        });
        this.addSizeSelection(content);
        this.hidden = false;
        opener.addEventListener('click', () => {
          this.syncSizeSelection();
          dialog.showModal();
        });
        this.querySelector('[data-chart-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => { if (opener.isConnected) opener.focus(); });
      }
      normalizeSize(value) {
        const size = value.trim().toUpperCase().replace(/[\s-]+/g, '');
        const aliases = { XXS: '2XS', XXXS: '3XS', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL' };
        return aliases[size] || size;
      }
      sizeOptions() {
        const picker = this.closest('product-info')?.querySelector('variant-selects');
        if (!picker) return [];
        return [...picker.querySelectorAll('input[type="radio"][data-option-name], option[data-option-name]')]
          .filter((option) => option.dataset.optionName.toLowerCase() === this.dataset.sizeLabel.toLowerCase());
      }
      matchingSize(value) {
        const options = this.sizeOptions();
        const exact = options.find((option) => option.value.trim().toLowerCase() === value.trim().toLowerCase());
        if (exact) return exact;
        const matches = options.filter((option) => this.normalizeSize(option.value) === this.normalizeSize(value));
        return matches.length === 1 ? matches[0] : null;
      }
      sizeAvailable(option) {
        return Boolean(option) && !option.disabled && option.dataset.variantAvailable !== 'false' &&
          !option.classList.contains('disabled');
      }
      addSizeSelection(content) {
        this.sizeChoices = [];
        content.querySelectorAll('table').forEach((table) => {
          const rows = [...table.rows];
          if (!rows.length) return;
          const columns = [...rows[0].cells].slice(1);
          const rowLabels = rows.slice(1).map((row) => row.cells[0]).filter(Boolean);
          const columnMatches = columns.filter((cell) => this.matchingSize(cell.textContent));
          const rowMatches = rowLabels.filter((cell) => this.matchingSize(cell.textContent));
          const horizontal = columnMatches.length >= rowMatches.length;
          (horizontal ? columnMatches : rowMatches).forEach((cell) => {
            const option = this.matchingSize(cell.textContent);
            const cells = horizontal ? rows.map((row) => row.cells[cell.cellIndex]).filter(Boolean) : [...cell.parentElement.cells];
            const button = this.sizeButton(option.value, cell.textContent.trim());
            cell.replaceChildren(button);
            cell.classList.add('kw-size-chart__size-cell');
            this.sizeChoices.push({ button, cells });
          });
        });
        if (!this.sizeChoices.length && this.sizeOptions().length) {
          const group = document.createElement('div');
          group.className = 'kw-size-chart__size-options';
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', this.dataset.sizeLabel);
          this.sizeOptions().forEach((option) => {
            const button = this.sizeButton(option.value, option.value);
            group.append(button);
            this.sizeChoices.push({ button, cells: [] });
          });
          content.append(group);
        }
        this.querySelector('[data-chart-hint]').hidden = !this.sizeChoices.length;
        this.syncSizeSelection();
      }
      sizeButton(value, label) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kw-size-chart__size';
        button.dataset.sizeValue = value;
        button.textContent = label;
        button.addEventListener('click', () => this.selectSize(value));
        return button;
      }
      syncSizeSelection() {
        this.sizeChoices.forEach(({ button, cells }) => {
          const option = this.matchingSize(button.dataset.sizeValue);
          const selected = option?.tagName === 'OPTION' ? option.selected : Boolean(option?.checked);
          button.disabled = !this.sizeAvailable(option);
          button.setAttribute('aria-pressed', String(selected));
          button.setAttribute('aria-label', `${this.dataset.selectLabel} ${button.textContent}${button.disabled ? ` — ${this.dataset.unavailableLabel}` : ''}`);
          cells.forEach((cell) => cell.classList.toggle('kw-size-chart__selected', selected));
        });
      }
      selectSize(value) {
        const option = this.matchingSize(value);
        if (!this.sizeAvailable(option)) {
          this.syncSizeSelection();
          return;
        }
        this.querySelector('dialog').close();
        const selected = option.tagName === 'OPTION' ? option.selected : option.checked;
        if (selected) return;
        const input = option.tagName === 'OPTION' ? option.closest('select') : option;
        if (input.tagName === 'SELECT') input.value = option.value;
        else input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      mobileTable(table) {
        // Swap axes on phones so every size fits without squeezing measurements.
        // Only normalized tables are transformed; supplier values are copied verbatim.
        const rows = [...table.rows];
        const header = rows[0];
        if (!header || !/^measurement$/i.test(header.cells[0]?.textContent.trim())) return null;
        if (rows.some((row) => row.cells.length !== header.cells.length || [...row.cells].some((cell) => cell.colSpan !== 1 || cell.rowSpan !== 1))) return null;
        const mobile = document.createElement('table');
        const heading = mobile.createTHead().insertRow();
        const appendHeading = (row, text, scope) => {
          const cell = document.createElement('th');
          cell.scope = scope;
          cell.textContent = text;
          row.append(cell);
        };
        appendHeading(heading, this.dataset.sizeLabel, 'col');
        rows.slice(1).forEach((row) => appendHeading(heading, row.cells[0].textContent, 'col'));
        const body = mobile.createTBody();
        for (let column = 1; column < header.cells.length; column++) {
          const row = body.insertRow();
          appendHeading(row, header.cells[column].textContent, 'row');
          rows.slice(1).forEach((source) => { row.insertCell().textContent = source.cells[column].textContent; });
        }
        return mobile;
      }
      descriptionChart(source) {
        const titlePattern = /^(?:size|sizing)\s*(?:chart|guide|information|measurements?)\b/i;
        const heading = [...source.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong')].find((element) => titlePattern.test(element.textContent.trim()) && element.textContent.trim().length < 90);
        if (heading) {
          const start = heading.closest('p') || heading;
          const fragment = document.createDocumentFragment();
          let sibling = start.nextSibling;
          while (sibling) {
            if (sibling.nodeType === 1 && /^H[1-6]$/.test(sibling.tagName) && !/^(?:inches|inch|in\b|cm\b|centimet(?:er|re)s|measurements?|how to measure|fit|size)/i.test(sibling.textContent.trim())) break;
            fragment.append(sibling.cloneNode(true));
            sibling = sibling.nextSibling;
          }
          if (fragment.querySelector('table,img')) return fragment;
        }
        const tables = [...source.querySelectorAll('table')].filter((table) => {
          const labels = [...table.querySelectorAll('th,td')].map((cell) => cell.textContent.trim()).join(' ');
          return /\b(size|xs|s|m|l|xl|xxl|2xl|3xl)\b/i.test(labels) && /\b(chest|bust|waist|hip|length|shoulder|sleeve|inseam|height)\b/i.test(labels);
        });
        if (tables.length) {
          const fragment = document.createDocumentFragment();
          tables.forEach((table) => {
            const label = table.previousElementSibling;
            if (label && /^(inches|cm|centimeters|centimetres|size)/i.test(label.textContent.trim())) fragment.append(label.cloneNode(true));
            fragment.append(table.cloneNode(true));
            const note = table.nextElementSibling;
            if (note?.matches('p') && /measure|fit|size|tolerance/i.test(note.textContent)) fragment.append(note.cloneNode(true));
          });
          return fragment;
        }
        const chartImage = [...source.querySelectorAll('img')].find((img) => /size[\s_-]*(chart|guide)/i.test(`${img.alt} ${img.getAttribute('src')}`));
        return chartImage ? chartImage.cloneNode(true) : null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kw-wishlist-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.getElementById('KwWishlistConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const t = config.strings;
  const root = config.root.replace(/\/?$/, '/');
  const wishlistPath = `${root}pages/wishlist`;
  const key = 'knollwoods:wishlist:v1';
  const limit = 100;
  const validHandle = handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle);
  const clean = value => Array.isArray(value) ? [...new Set(value.filter(validHandle))].slice(0, limit) : [];
  const decode = value => { try { return clean(JSON.parse(value)); } catch { return []; } };
  let storageAvailable = true;
  let items = [];
  try { items = decode(localStorage.getItem(key)); } catch { storageAvailable = false; }
  const subscribers = new Set();
  const read = () => {
    if (storageAvailable) { try { items = decode(localStorage.getItem(key)); } catch { storageAvailable = false; } }
    return [...items];
  };
  const announce = text => {
    const node = document.getElementById('KwWishlistStatus');
    if (node) node.textContent = text;
  };
  const notify = () => {
    document.querySelectorAll('[data-wishlist-count]').forEach(node => {
      node.textContent = String(items.length);
      node.hidden = !items.length;
    });
    subscribers.forEach(callback => callback());
  };
  const save = value => {
    items = clean(value);
    try { localStorage.setItem(key, JSON.stringify(items)); storageAvailable = true; }
    catch { storageAvailable = false; }
    notify();
  };
  const toggle = handle => {
    if (!validHandle(handle)) return;
    const current = read();
    const exists = current.includes(handle);
    if (!exists && current.length >= limit) { announce(t.limit); return; }
    save(exists ? current.filter(item => item !== handle) : [...current, handle]);
    announce(storageAvailable ? (exists ? t.removed : t.added) : t.storage_error);
  };
  const snapshot = hash => {
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    return params.has('items') ? clean((params.get('items') || '').slice(0, 26000).split(',')) : null;
  };
  const shareURL = handles => {
    const url = new URL(wishlistPath, location.origin);
    url.hash = new URLSearchParams({ items: clean(handles).join(',') }).toString();
    return url.href;
  };
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) { read(); notify(); }
  });
  window.addEventListener('pageshow', () => { read(); notify(); });

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button || !validHandle(this.dataset.handle)) return;
      this.update = () => {
        const saved = items.includes(this.dataset.handle);
        this.button.disabled = false;
        this.button.setAttribute('aria-pressed', String(saved));
        this.button.setAttribute('aria-label', (saved ? t.remove_product : t.save_product).replace('[title]', this.dataset.title || ''));
        const label = this.querySelector('[data-wishlist-label]');
        if (label) label.textContent = saved ? t.saved : t.save;
      };
      this.click = event => { event.preventDefault(); toggle(this.dataset.handle); };
      this.button.addEventListener('click', this.click);
      subscribers.add(this.update);
      this.update();
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.click);
      subscribers.delete(this.update);
    }
  }
  if (!customElements.get('kw-wishlist-button')) customElements.define('kw-wishlist-button', WishlistButton);

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cache = new Map();
      this.generation = 0;
      this.find = name => this.querySelector(`[data-wishlist-${name}]`);
      this.shared = snapshot(location.hash);
      this.onHash = () => { this.shared = snapshot(location.hash); this.find('link').hidden = true; this.render(); };
      this.onStore = () => { if (this.shared === null) this.render(); };
      window.addEventListener('hashchange', this.onHash, options);
      subscribers.add(this.onStore);
      this.find('copy').addEventListener('click', () => this.copyLink(), options);
      this.find('share').addEventListener('click', () => this.nativeShare(), options);
      this.find('merge').addEventListener('click', () => {
        const merged = [...new Set([...read(), ...this.shared])];
        save(merged);
        this.feedback(merged.length > limit ? t.limit : storageAvailable ? t.merged : t.storage_error);
      }, options);
      this.find('url').addEventListener('click', event => event.target.select(), options);
      this.render();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.fetchController?.abort();
      subscribers.delete(this.onStore);
      this.generation++;
    }
    handles() { return this.shared === null ? [...items] : [...this.shared]; }
    feedback(text) { this.find('feedback').textContent = text; }
    showLink() {
      const input = this.find('url');
      input.value = shareURL(this.handles());
      this.find('link').hidden = false;
      return input.value;
    }
    async copyLink() {
      const url = this.showLink();
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        this.feedback(t.copied);
      } catch {
        this.find('url').focus();
        this.find('url').select();
        this.feedback(t.copy_fallback);
      }
    }
    async nativeShare() {
      try { await navigator.share({ title: t.title, url: this.showLink() }); }
      catch (error) { if (error.name !== 'AbortError') await this.copyLink(); }
    }
    async product(handle, signal) {
      if (this.cache.has(handle)) return this.cache.get(handle);
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { signal, credentials: 'same-origin' });
      if (response.status === 404) return null;
      if (!response.ok) throw new Error('Product request failed');
      const product = await response.json();
      if (!product || typeof product.title !== 'string' || typeof product.price !== 'number') throw new Error('Invalid product');
      this.cache.set(handle, product);
      return product;
    }
    money(cents) {
      return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100);
    }
    async render() {
      const generation = ++this.generation;
      this.fetchController?.abort();
      this.fetchController = new AbortController();
      const signal = this.fetchController.signal;
      const shared = this.shared !== null;
      const handles = this.handles();
      this.find('title').textContent = shared ? t.shared_title : t.title;
      this.find('intro').textContent = shared ? t.shared_intro : t.intro;
      this.find('storage').hidden = shared;
      this.find('toolbar').hidden = !handles.length && !shared;
      this.find('merge').hidden = !shared || !handles.length;
      this.find('mine').hidden = !shared;
      this.find('share').hidden = !navigator.share || !handles.length;
      this.find('copy').hidden = !handles.length;
      this.find('total').textContent = (handles.length === 1 ? t.single_count : t.count).replace('[count]', handles.length);
      this.find('empty').hidden = !!handles.length;
      if (!this.find('link').hidden) {
        this.find('url').value = shareURL(handles);
        if (!handles.length) this.find('link').hidden = true;
      }
      this.feedback(handles.length ? t.loading : shared ? t.invalid : '');
      const grid = this.find('grid');
      grid.replaceChildren();
      grid.setAttribute('aria-busy', String(!!handles.length));
      const slots = handles.map(handle => {
        const fragment = this.find('card').content.cloneNode(true);
        const card = fragment.querySelector('li');
        const remove = card.querySelector('[data-product-remove]');
        remove.hidden = shared;
        remove.addEventListener('click', () => {
          const index = handles.indexOf(handle);
          toggle(handle);
          const next = this.find('grid').querySelectorAll('[data-product-remove]');
          (next[Math.min(index, next.length - 1)] || this.find('empty').querySelector('a')).focus();
        });
        card.querySelector('[data-product-title]').textContent = t.loading;
        card.querySelector('[data-product-image]').hidden = true;
        card.querySelector('[data-product-shop]').hidden = true;
        grid.append(fragment);
        return card;
      });
      let cursor = 0;
      const worker = async () => {
        while (cursor < handles.length && generation === this.generation) {
          const index = cursor++;
          const handle = handles[index];
          const card = slots[index];
          try {
            const product = await this.product(handle, signal);
            if (generation !== this.generation) return;
            this.populate(card, handle, product);
          } catch (error) {
            if (generation !== this.generation || error.name === 'AbortError') return;
            this.populate(card, handle, null, true);
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, handles.length) }, worker));
      if (generation !== this.generation) return;
      grid.setAttribute('aria-busy', 'false');
      this.feedback(shared && !handles.length ? t.invalid : !storageAvailable ? t.storage_error : '');
    }
    populate(card, handle, product, failed = false) {
      const title = card.querySelector('[data-product-title]');
      const status = card.querySelector('[data-product-status]');
      const remove = card.querySelector('[data-product-remove]');
      title.textContent = product ? product.title : handle.replace(/-/g, ' ');
      remove.setAttribute('aria-label', t.remove_product.replace('[title]', title.textContent));
      status.hidden = !!product?.available;
      status.textContent = failed ? t.fetch_error : !product ? t.unavailable : t.sold_out;
      if (failed) {
        const retry = card.querySelector('[data-product-retry]');
        retry.hidden = false;
        retry.addEventListener('click', () => this.render());
      }
      if (!product) return;
      const url = `${root}products/${encodeURIComponent(handle)}`;
      card.querySelectorAll('[data-product-link], [data-product-title], [data-product-shop]').forEach(link => link.href = url);
      card.querySelector('[data-product-shop]').hidden = false;
      card.querySelector('[data-product-link]').setAttribute('aria-label', product.title);
      card.querySelector('[data-product-price]').textContent = product.price_varies ? t.from.replace('[price]', this.money(product.price)) : this.money(product.price);
      if (product.featured_image) {
        try {
          const src = new URL(product.featured_image, location.origin);
          if (src.protocol !== 'https:' && src.protocol !== 'http:') return;
          src.searchParams.set('width', '700');
          const image = card.querySelector('[data-product-image]');
          image.src = src.href;
          image.alt = product.title;
          image.hidden = false;
        } catch { /* A product without a valid image retains its neutral placeholder. */ }
      }
    }
  }
  if (!customElements.get('kw-wishlist-page')) customElements.define('kw-wishlist-page', WishlistPage);
  notify();
})();
  } catch(e) { console.error(e); }
})();

})();
